import {useTranslation} from 'react-i18next';

const AnonymizedStepCompletionData: React.FC = () => {
  const {t} = useTranslation('components', {
    keyPrefix: 'campaigns.challenges.anonymizedStepCompletionData',
  });

  return <span className="text-sm italic text-slate-500">{t('dataAnonymized')}</span>;
};

export default AnonymizedStepCompletionData;
